import React from "react";
import map from "../../assets/services/map.png";
import Vector3 from "../../assets/services/Vector3.png";
import { useTranslation } from "react-i18next";

const FindSamoolah = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div className="my-14 max-lg:my-5">
      <div className="px-20 max-lg:px-5 relative">
        <h2 className="text-[#14294F] text-3xl max-lg:text-2xl font-semibold">
          {t("findSamoolah.title")}
        </h2>
        <p className="text-[#737E91] text-lg mt-3 w-3/5 max-lg:w-full">
          {t("findSamoolah.description")}
        </p>
        <img src={Vector3} className={`w-[400px] max-lg:w-[120px] absolute right-28 max-lg:right-2 -top-8 max-lg:top-28 ${language == "ar" && "hidden"}`}/>
      </div>
      <div dir="ltr">
        <img src={map} className={`w-3/4 max-lg:w-5/6 `}/>
      </div>
    </div>
  );
};

export default FindSamoolah;